// extracted by mini-css-extract-plugin
module.exports = {"container":"success_container__3_dIv","title":"success_title__vMClK","btn":"success_btn__5pY0D"};